'use strict';

var _ = require('lodash');
var PendingUserRequestController = function PendingUserRequestController($scope, UserManagementConstants, pendingUserRequestService, userSummaryBoxService) {
  $scope.height = 61;
  $scope.selectedUser = [{
    name: $scope.user.firstName + ' ' + $scope.user.lastName,
    userId: $scope.user.userId,
    email: $scope.user.email,
    cityCode: $scope.user.cityCode,
    role: $scope.user.role,
    isSabreEmployee: $scope.user.isSabreEmployee,
    isSystemOwner: $scope.user.isSystemOwner
  }];
  userSummaryBoxService.getUserNumbers().then(function (userSummary) {
    if (typeof $scope.selectedUser[0].isSabreEmployee === 'undefined' || !$scope.selectedUser[0].isSabreEmployee) {
      $scope.reachMaxLimit = userSummary.availableUserAccounts <= 0;
    } else {
      $scope.reachMaxLimit = false;
    }
  });
  var roleCellRenderer = function roleCellRenderer(params) {
    return '<rm-combobox item-list="roleOptions" type-ahead="true" ' + 'fixed-position="true" ng-model="selectedUser[' + params.rowIndex + '].role"></rm-combobox>';
  };
  var columnDefs = {};
  columnDefs = [{
    headerName: 'Name',
    field: 'name',
    cellClass: 'ag-cell-center'
  }, {
    headerName: 'User ID',
    field: 'userId',
    cellClass: 'ag-cell-center'
  }, {
    headerName: 'Email Address',
    field: 'email',
    cellClass: 'ag-cell-center'
  }, {
    headerName: 'Location',
    field: 'cityCode',
    cellClass: 'ag-cell-center'
  }, {
    headerName: 'Role',
    field: 'role',
    cellRenderer: roleCellRenderer
  }];
  pendingUserRequestService.getRoles().then(function (roles) {
    $scope.roleOptions = roles;
    $scope.gridOptions = {
      columnDefs: columnDefs,
      rowData: $scope.selectedUser,
      suppressCellSelection: true,
      angularCompileRows: true,
      rowHeight: 35
    };
  });
  $scope.isGridOptionsAvailable = function () {
    return !_.isUndefined($scope.gridOptions);
  };
  $scope.cancel = function () {
    $scope.$emit('user-management-manage-users:change-screen', UserManagementConstants.MANAGE_USERS_SCREENS.MANAGE_ACCESS_REQUESTS);
  };
};
PendingUserRequestController.$inject = ['$scope', 'UserManagementConstants', 'PendingUserRequestService', 'UserSummaryPanelService'];
module.exports = PendingUserRequestController;